<div class="loader-wrapper">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <kendo-grid
                [resizable]="true"
                [data]="itemsGridView"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [sort]="sort"
                [selectable]="selectableSettings"
                [kendoGridSelectBy]="selectionCallback"
                [selectedKeys]="selected"
                [rowSelected]="isRowSelected"
                (pageChange)="pageChange($event, attachmentsArray)"
                (sortChange)="sortChange($event, attachmentsArray)"
                (selectedKeysChange)="keyChange($event)">
                @if (showRestrictedButtons) {
                    <ng-template kendoGridToolbarTemplate>
                        <button
                            class="btn btn-sm btn-primary"
                            kendoTooltip
                            title="{{ 'Add Attachment' | translate }}"
                            [disabled]="!active"
                            (click)="openDialogAddAttachment()">
                            <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                        </button>
                        <button
                            class="btn btn-sm btn-danger"
                            kendoTooltip
                            title="{{ 'Remove' | translate }} {{ selected.length }} {{
                                (selected.length > 1 ? 'Attachments' : 'Attachment') | translate
                            }}"
                            [disabled]="!canRemove()"
                            (click)="openDialogRemoveAttachments()">
                            <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            @if (selected.length) {
                                <span class="badge badge-pill badge-light ml-1">
                                    {{ selected.length }}
                                </span>
                            }
                        </button>
                    </ng-template>
                }
                @if (active) {
                    <kendo-grid-checkbox-column [showSelectAll]="true" [width]="50"></kendo-grid-checkbox-column>
                }
                <kendo-grid-column title="{{ 'Name' | translate }}" field="name">
                    <ng-template kendoGridCellTemplate let-row>
                        <a class="download-link" (click)="downloadAttachment(row.attachedFile)">
                            {{ row.name }}
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Description' | translate }}" field="description"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Created By' | translate }}" field="createdBy"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Date' | translate }}" field="createdDate">
                    <ng-template kendoGridCellTemplate let-row>
                        {{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>

            @if (dialogAddAttachment) {
                <kendo-dialog
                    title="{{ 'Add Attachment' | translate }}"
                    [width]="560"
                    [maxWidth]="'95vw'"
                    (close)="closeDialogAddAttachment()">
                    <div class="mb-1">
                        <span>{{ 'Description:' | translate }}</span>
                    </div>
                    <div class="mb-3">
                        <kendo-textarea
                            class="w-100"
                            #attachmentDescriptionTextArea
                            resizable="none"
                            [rows]="3"></kendo-textarea>
                    </div>
                    <div class="mb-1">
                        <span>{{ 'Attachment: ' | translate }}</span>
                        @if (attachmentSettingsLoaded) {
                            <i
                                class="fa fa-info-circle ml-1"
                                kendoTooltip
                                aria-hidden="true"
                                [title]="attachmentTooltip"></i>
                        }
                    </div>
                    <div class="mb-2 attachment-fileselect">
                        <kendo-fileselect
                            [restrictions]="attachmentFileUploadRestrictions"
                            [multiple]="false"
                            (select)="fileSelected($event)"
                            (remove)="fileRemoved($event)">
                            <kendo-upload-messages
                                select="{{ 'Select File...' | translate }}"
                                dropFilesHere="{{ 'Drop file here to select' | translate }}"></kendo-upload-messages>
                        </kendo-fileselect>
                    </div>
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            kendoButton
                            [disabled]="submittingAttachment || !fileToSent"
                            (click)="addAttachment()">
                            <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Add' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeDialogAddAttachment()">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }

            @if (dialogRemoveAttachments) {
                <kendo-dialog
                    title="{{ 'Remove Selected Items' | translate }}"
                    (close)="closeDialogRemoveAttachments()">
                    <span>{{ 'Are you sure that you want to remove selected items?' | translate }}</span>
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary"
                            kendoButton
                            [disabled]="removingAttachments"
                            (click)="removeAttachments()">
                            <fa-icon [icon]="['fas', 'minus']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Remove' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeDialogRemoveAttachments()">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }
        </ng-template>
    </app-loader>
</div>
